import { Controller } from "@hotwired/stimulus";
import { createIcons, Edit2, MinusCircle, PlusCircle, Trash } from "lucide";

// Caution, this will import all the icons and bundle them.
// createIcons({ icons });

// Recommended way, to include only the icons you need.
// import { createIcons, Menu, ArrowRight, Globe } from 'lucide';

// createIcons({
//   icons: {
//     Menu,
//     ArrowRight,
//     Globe
//   }
// });

// Connects to data-controller="lucide"
export default class extends Controller {
  connect() {
    createIcons({
      icons: {
        PlusCircle,
        MinusCircle,
        Edit2,
        Trash
      }
    });
  }
}
